import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import wechat from './modules/wechat';
import booking from './modules/booking';
import month from './modules/month';
import appInfo from './modules/appInfo';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        wechat,
        booking,
        month,
        appInfo
    },
    getters
});

export default store;